//For recently viewed dropdown
function check_Validvalue(selector){

    if(parseInt(selector.value) !== 0 && selector.classList.contains('invalidSelection')){
      selector.classList.remove('invalidSelection');
    }
  }
  

// Functions to check if variant is selected on PDP 
       //---- for product page -----//
   
       function isVariantchecked(list){
    const inputElem = list.querySelector('input');
    const buynow = document.querySelector('.duplicate_buynow');
    if(inputElem.checked){
        document.querySelectorAll('.selection-warning-text').forEach(warning => {
            warning.classList.add('hidden-warning');
        });
        if(buynow && !buynow.classList.contains('hide-dupe')){
            buynow.classList.add('hide-dupe');
            buynow.parentElement.querySelector('#gokwik-buy-now').classList.remove('buynow-hidden');
        }
    }
}

function warnuser(button){
    const atcButton = button;
    let options = document.querySelectorAll('#foruser_variantSelection .SizeSwatch__Radio');
    let variantSelected = Array.from(options).find(x => x.checked) ? true : false;
    const scrollToElement = document.querySelector('.ProductMeta');
    if(variantSelected){
        document.querySelectorAll('.selection-warning-text').forEach(warning => {
            warning.classList.add('hidden-warning');
        });
        if(button.classList.contains('duplicate_buynow')){
            const buynow = button.parentElement.querySelector('#gokwik-buy-now');
            buynow.type='submit';
            button.classList.add('hide-dupe');
            buynow.classList.remove('buynow-hidden');
        } else {
            atcButton.type='submit';
            atcButton.setAttribute("data-action", "add-to-cart");
        }  
    } else {
        document.querySelectorAll('.selection-warning-text').forEach(warning => {
            scrollToElement.scrollIntoView({ behavior: 'smooth' });
            warning.classList.remove('hidden-warning');
            
        });
        if(button.classList.contains('duplicate_buynow')){
            const buynow = button.parentElement.querySelector('#gokwik-buy-now');
            buynow.type='button';
            buynow.classList.add('buynow-hidden');
            button.classList.remove('hide-dupe');
        } else {
            atcButton.setAttribute.type='button';
            atcButton.setAttribute("data-action", "");
        }          
    }
}
